import { takeEvery } from 'redux-saga/effects';

import { create } from 'store/modules/listing/customPrices';

import * as customPrices from './utils';

export default function* listenCreateCustomPrice() {
  yield takeEvery(create.toString(), customPrices.create);
}
